import { render } from "./BackupScheduleWizard.vue?vue&type=template&id=61376678&scoped=true"
import script from "./BackupScheduleWizard.vue?vue&type=script&lang=js"
export * from "./BackupScheduleWizard.vue?vue&type=script&lang=js"

import "./BackupScheduleWizard.vue?vue&type=style&index=0&id=61376678&scoped=true&lang=less"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61376678"]])

export default __exports__